import { Component, Input, OnChanges, OnInit } from '@angular/core'
import { ExcelExportData } from '@progress/kendo-angular-excel-export'
import { process } from '@progress/kendo-data-query'
import { ClientServices } from '../../../../@theme/services/clients.service'
import { NgIf, NgFor } from '@angular/common';
import { GridComponent, DataBindingDirective, ToolbarTemplateDirective, ExcelCommandDirective, GridToolbarFocusableDirective, ColumnComponent, ExcelComponent } from '@progress/kendo-angular-grid';

@Component({
    selector: 'gd-rep-reports',
    templateUrl: './rep-reports.component.html',
    styleUrls: ['./rep-reports.component.scss'],
    imports: [
        NgIf,
        GridComponent,
        DataBindingDirective,
        ToolbarTemplateDirective,
        ExcelCommandDirective,
        GridToolbarFocusableDirective,
        NgFor,
        ColumnComponent,
        ExcelComponent,
    ]
})
export class RepReportsComponent implements OnChanges {
  @Input() repReportId: string
  @Input() reportParams: Record<string, unknown>
  reportData: any

  constructor(private clientServices: ClientServices) {
    this.allData = this.allData.bind(this)
  }

  ngOnChanges() {
    const i = {
      repReportId: this.repReportId,
      genericParams: this.reportParams,
    }
    this.clientServices
      .getReportData({
        repReportId: this.repReportId,
        genericParams: this.reportParams,
      })
      .subscribe((response) => {
        this.reportData = response
      })
  }

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: process(this.reportData.rows, {}).data,
    }

    return result
  }
}
